export const config = {
	textField: {
		hint: 'Format JJ/MM/AAAA',
		label: 'Date',
		persistentHint: true,
		validateOnBlur: false
	},
	menu: {
		minWidth: '290px',
		closeOnContentClick: false,
		contentClass: 'vd-date-picker-menu'
	},
	btn: {
		icon: true
	},
	datePicker: {
		firstDayOfWeek: 1,
		noTitle: true,
		locale: 'fr'
	},
	icon: {
		color: '#808080'
	}
};
